export default __webpack_public_path__ + "static/media/steve-jobs.f9dcbdc1.png";